module.exports = __webpack_public_path__ + "img/dingzhi.2ad3f33d.png";